import map from 'lodash/map';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import { shippingHeaderFields } from 'components/Settings/fieldsConstants';

const ShippingByCountryHeader = () => (
  <Row align="middle" gutter={[20, 5]}>
    {map(shippingHeaderFields, ({ span, title, questionMark }) =>
      <Col key={title} span={span} className="flex items-center">
        Shipping {title}
        <QuestionMark>{questionMark}</QuestionMark>
      </Col>)}
  </Row>
);

export default ShippingByCountryHeader;
